import differenceInMinutes from "date-fns/differenceInMinutes";
import {
  globalGraphClient,
  getGraphClientFromAccessToken,
  getFileIdFromDriveInfo,
  getFileUrlFromDriveInfo,
  getSessionFromDriveInfo,
  checkPublicAccessToken,
} from "../GraphMain";
import {
  writeLiveChanges,
  writeLiveCellArray,
  getLiveTargetValues,
  getLiveTargetValuesForChanges,
  getLiveTargetLookups,
  getLiveRangeValues,
  getLiveCellValue,
  setLiveTargetValues,
  sendSessionPing,
} from "./graphLiveChanges";
import store from "../StoreRoot";

const reloadOnError = true;

export class moduleSimulationGraph {
  liveSessionList = [];

  //==========================
  // SESSION MANAGEMENT
  //==========================

  async getNonPersistingSessionFromDriveInfo(accessInfo) {
    const fileId = getFileIdFromDriveInfo(accessInfo.driveItemInfo);
    let foundSession = null;

    // =============================
    // look for an existing session
    // =============================
    foundSession = this.liveSessionList.find((obj) => {
      return obj.fileId === fileId;
    });
    if (foundSession) {
      // check the timestamp
      const timeNow = new Date();
      const timeStamp = foundSession.timeStamp;
      // const creationTimeStamp = foundSession.creationTimeStamp;
      const sessionAgeInMinutes = differenceInMinutes(timeNow, timeStamp);

      if (sessionAgeInMinutes <= 7) {
        console.log("LIVESESSION found: ageInMinutes", sessionAgeInMinutes);
        foundSession.status = "reused";
        foundSession.timeStamp = timeNow;
        return foundSession;
        // } else if (sessionAgeInMinutes <= 6) {
        //   console.log("LIVESESSION found needs a refresh", sessionAgeInMinutes);
        //   // ============================
        //   // try to refresh this session
        //   // ============================
        //   const refreshedSession = await this.refreshNonPersistingSession(
        //     foundSession,
        //     accessInfo
        //   );
        //   if (refreshedSession) {
        //     console.log("LIVESESSION refresh was successful", refreshedSession);
        //     return refreshedSession;
        //   }
      } else {
        // ============================
        // it is too old - remove it
        // ============================
        console.log("LIVESESSION found session too old", sessionAgeInMinutes);
        this.deleteNonPersistingSession(foundSession);
      }
    }

    // ============================
    // CREATE A NEW SESSION
    // ============================
    const fileUrl = getFileUrlFromDriveInfo(accessInfo.driveItemInfo);
    let client = globalGraphClient;
    let accessToken;
    let newSession;
    // get a new one
    try {
      let sessionInfo = null;
      // if it is connector based - create a graph client
      const connectorId = accessInfo.connectorId;
      console.log("LIVESESSION needs to be created", connectorId);
      if (connectorId) {
        const staticSession = getSessionFromDriveInfo(accessInfo.driveItemInfo);
        accessToken = staticSession?.accessToken;
        // get a public client
        if (accessToken) {
          client = getGraphClientFromAccessToken(accessToken);
        } else {
          // TODO create a new accessToken
          console.log("LIVESESSION missing connector accesstoken - creating");
          client = await checkPublicAccessToken(accessInfo, null);
        }

        if (!client) {
          console.log("LIVESESSION no client - creating");
          client = await checkPublicAccessToken(accessInfo, null);
        }
      }
      // last check
      if (!client) {
        console.log("LIVESESSION no client 2");
        client = globalGraphClient;
      }
      if (!client) {
        if (reloadOnError === true) store.reloadPage();
        return;
      }
      // create a new session
      const workbookSessionInfo = { persistChanges: false };
      let sessionError = false;
      sessionInfo = await client
        .api(fileUrl + "/workbook/createSession")
        .post(workbookSessionInfo)
        .catch((error) => {
          console.error(
            "Error createLiveSession",
            error.name,
            error.message,
            error.code,
            error
          );
          // check access token expiration
          if (error.code === 401) {
            // TODO: get a new access token
          }
          if (
            error.name.includes("expired") ||
            error.message.includes("expired")
          ) {
            if (reloadOnError === true) store.reloadPage();
          }

          sessionError = true;
        });
      if (sessionInfo && sessionError === false) {
        const timeNow = new Date();
        // create a new session entry
        newSession = {
          fileId: fileId,
          sessionId: sessionInfo.id,
          timeStamp: timeNow,
          creationTimeStamp: timeNow,
          accessToken: accessToken,
          client: accessToken && client,
          status: "new",
        };
        this.liveSessionList.push(newSession);
      }
      return newSession;
    } catch (err) {
      console.log("ERROR getLiveSession", err);
      console.log("ERROR getLiveSession fileUrl", fileUrl, accessInfo);
    }
  }

  async deleteNonPersistingSession(foundSession) {
    if (!foundSession) return null;

    let foundIndex = this.liveSessionList.findIndex((obj) => {
      return obj.fileId === foundSession.fileId;
    });
    // delete the entry from the list
    if (foundIndex !== -1) {
      this.liveSessionList.splice(foundIndex, 1);
    } else {
      this.liveSessionList.length = 0;
    }
  }

  // async updateNonPersistingSession(accessInfo, newSession) {
  //   const fileId = getFileIdFromDriveInfo(accessInfo.driveItemInfo);
  //   let foundSession = null;
  //   // =============================
  //   // look for an existing session
  //   // =============================
  //   foundSession = this.liveSessionList.find((obj) => {
  //     return obj.fileId === fileId;
  //   });
  //   if (foundSession && newSession) {
  //     // delete the old entry
  //     let foundIndex = this.liveSessionList.findIndex((obj) => {
  //       return obj.fileId === fileId;
  //     });
  //     // update the entry from the list
  //     if (foundIndex !== -1) {
  //       this.liveSessionList.splice(foundIndex, 1);
  //       // push the new one
  //       this.liveSessionList.push(newSession);
  //     }
  //   } else {
  //     console.log("updateNonPersistingSession no existing session found");
  //   }
  // }

  async closeNonPersistingSession(accessInfo) {
    if (!accessInfo) return;

    try {
      const fileId = getFileIdFromDriveInfo(accessInfo.driveItemInfo);
      const fileUrl = getFileUrlFromDriveInfo(accessInfo.driveItemInfo);
      // look for an existing session
      let foundSession = this.liveSessionList.find((obj) => {
        return obj.fileId === fileId;
      });

      if (foundSession) {
        let sessionId = foundSession.sessionId;
        // create a public client
        let client = globalGraphClient;
        if (foundSession.accessToken) {
          client = getGraphClientFromAccessToken(foundSession.accessToken);
        }
        const workbookSessionInfo = {};
        await client
          .api(fileUrl + "/workbook/closeSession")
          .header("workbook-session-id", sessionId)
          .post(workbookSessionInfo)
          .catch((error) => {
            console.error(
              "Error closeNonPersistingSession",
              error.name,
              error.message
            );
          });
        let foundIndex = this.liveSessionList.findIndex((obj) => {
          return obj.fileId === fileId;
        });
        // delete the entry from the list
        if (foundIndex !== -1) {
          this.liveSessionList.splice(foundIndex, 1);
        }
      }
    } catch (err) {
      console.log("ERROR closeNonPersistingSession", err);
    }
  }

  async useSessionPing(elementInfo, errorCallback) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return "error";

    let sessionId = session.sessionId;
    let client = session.client ? session.client : globalGraphClient;
    if (!client) {
      console.log("INFO useSessionPing - no client");
      return "error";
    }

    try {
      await sendSessionPing(elementInfo, sessionId, client, errorCallback);
    } catch (err) {
      console.log("ERROR - sendSessionPing", err);
    }
  }

  //==========================
  // FUNCTIONALITY
  //==========================

  checkClient(client) {
    // refresh page
    if (!client && reloadOnError) store.reloadPage();

    return client;
  }

  async getInitialLiveResults(elementInfo, targetList) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - initial", session.status);

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    let result;
    let lookups;
    let promiseValues;
    let promiseLookups;

    promiseValues = getLiveTargetValues(
      elementInfo,
      sessionId,
      targetList,
      null,
      client
    );
    // are there any lookup addresses
    let targetsWithSourceAddress = targetList.filter(
      (item) => item.source_address && item.source_address.length > 0
    );
    const withLookups = targetsWithSourceAddress.length > 0;

    if (withLookups) {
      promiseLookups = await getLiveTargetLookups(
        elementInfo,
        sessionId,
        targetsWithSourceAddress,
        client
      );
    }
    // await both
    if (withLookups) {
      [result, lookups] = await Promise.all([promiseValues, promiseLookups]);
    } else {
      result = await promiseValues;
    }

    return { targets: result, lookups: lookups };
  }

  async setUpdatedLiveValues(elementInfo, targetList) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - updated", session.status);

    if (session.status === "new") {
      // there is a new session - we need to recalc all our values
      console.log("SESSION is new - we need to recalculate all values");

      for (let target of targetList) {
        if (target.direction === "in") {
          // add all variables
          target.changed = true;
        }
      }
    }

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    let result;

    try {
      // promiseValues = getLiveTargetValuesForChanges(
      result = await setLiveTargetValues(
        elementInfo,
        sessionId,
        targetList,
        client
      );
    } catch (err) {
      let error = err?.message ?? "";
      console.log("ERROR - setUpdatedLiveValues", err);
      if (error.includes("session")) {
        // reset the session
        console.log("INFO deleting invalid session", sessionId);
        this.deleteNonPersistingSession(session);
      } else if (error.includes("expired") || error.includes("undefined")) {
        // reset the session
        console.log("INFO token has expired/undefined", sessionId);
        // refresh page
        if (reloadOnError === true) store.reloadPage();
      } else {
        console.log("ERROR", err);
        store.main.setLocalStoreValue("lastError", err.message);
      }
    }
    return { targets: result };
  }

  async getUpdatedLiveResults(elementInfo, targetList, targetLookups) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - updated", session.status);

    if (session.status === "new") {
      // there is a new session - we need to recalc all our values
      console.log("SESSION is new - we need to recalculate all values");

      for (let target of targetList) {
        if (target.direction === "in") {
          // add all variables
          target.changed = true;
        }
      }
    }

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    let result;
    let lookups;

    // let promiseValues;
    // let promiseLookups;

    try {
      // promiseValues = getLiveTargetValuesForChanges(
      result = await getLiveTargetValuesForChanges(
        elementInfo,
        sessionId,
        targetList,
        client
      );
      // are there any dynamic lookup addresses
      if (targetLookups) {
        // promiseLookups = getLiveTargetLookups(
        lookups = await getLiveTargetLookups(
          elementInfo,
          sessionId,
          targetLookups,
          client
        );
      }

      // await both
      // if (targetLookups) {
      //   [result, lookups] = await Promise.all([promiseValues, promiseLookups]);
      // } else {
      //   result = await promiseValues;
      // }
    } catch (err) {
      let error = err?.message ?? "";
      console.log("ERROR - getLiveTargetValuesForChanges", err);
      if (error.includes("session")) {
        // reset the session
        console.log("INFO deleting invalid session", sessionId);
        this.deleteNonPersistingSession(session);
      } else if (error.includes("expired") || error.includes("undefined")) {
        // reset the session
        console.log("INFO token has expired/undefined", sessionId);
        // refresh page
        if (reloadOnError === true) store.elements.reloadPage();
      } else {
        console.log("ERROR", err);
        store.main.setLocalStoreValue("lastError", err.message);
        // refresh page
        // if (reloadOnError === true) store.reloadPage();
      }
    }
    return { targets: result, lookups: lookups };
  }

  async sendChangesAndGetLiveResults(
    elementInfo,
    changesList,
    changesListPrior,
    messageCallback
  ) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - changes", session.status);

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    const result = await writeLiveChanges(
      elementInfo,
      sessionId,
      changesList,
      changesListPrior,
      client
    );
    return result;
    // if (!result) return;

    // if (messageCallback) {
    //   messageCallback(result);
    // }
  }

  async getLiveRangeResults(elementInfo, rangesList, callback) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - changes", session.status);

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    const result = await getLiveRangeValues(
      elementInfo,
      sessionId,
      rangesList,
      client
    );
    return result;
  }

  async getLiveCellAddressValue(elementInfo, address) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - changes", session.status);

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    const result = await getLiveCellValue(
      elementInfo,
      sessionId,
      address,
      client
    );
    return result;
  }

  async setLiveCellValues(elementInfo, array, targetCell, fields) {
    let session = await this.getNonPersistingSessionFromDriveInfo(
      elementInfo.accessInfo
    );
    if (!session) return;
    console.log("SESSION status - changes", session.status);

    let sessionId = session.sessionId;
    let client = this.checkClient(
      session.client ? session.client : globalGraphClient
    );
    const result = await writeLiveCellArray(
      elementInfo,
      sessionId,
      client,
      array,
      targetCell,
      fields
    );
    return result;
  }
}

// async refreshNonPersistingSession(foundSession, accessInfo) {
//   if (!foundSession) return null;
//   if (!foundSession.client) {
//     console.log("ERROR refreshNonPersistingSession no client");
//     return null;
//   }
//   // try to get it
//   const fileUrl = getFileUrlFromDriveInfo(accessInfo.driveItemInfo);
//   const sessionId = foundSession.sessionId;

//   const workbookSessionInfo = {};
//   const newSession = await foundSession.client
//     .api(fileUrl + "/workbook/refreshSession")
//     .header("workbook-session-id", sessionId)
//     .post(workbookSessionInfo);
//   // .then((data) => {
//   //   console.log("LIVESESSION refreshed", sessionId);
//   //   // update the timestamp
//   //   foundSession.timeStamp = new Date();
//   //   return foundSession;
//   // })
//   // .catch((err) => {
//   //   console.log("ERROR refreshing LiveSession", err);
//   //   return null;
//   // });

//   if (newSession) {
//     this.deleteNonPersistingSession(foundSession);
//     // create a new session entry
//     const newSessionEntry = {
//       fileId: foundSession.fileId,
//       sessionId: newSession.id,
//       timeStamp: new Date(),
//       accessToken: foundSession.accessToken,
//       client: foundSession.client,
//       status: "refreshed",
//     };
//     console.log("LIVESESSION refreshed", newSession);
//     console.log("LIVESESSION before refresh", foundSession);
//     this.liveSessionList.push(newSessionEntry);
//   } else {
//     console.log("ERROR refreshing LiveSession too old", newSession);
//     this.deleteNonPersistingSession(foundSession);
//   }
//   return newSession;
// }
